/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var KonturInstallIcon16Light = forwardRef('KonturInstallIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M9.164 8.457a1.25 1.25 0 1 0-.707.707l2.19 2.19a.5.5 0 0 0 .707-.708l-2.19-2.189Z" }),
        React.createElement("path", { d: "M7.684 4.485a.47.47 0 1 1-.084-.938 4.527 4.527 0 0 1 3.754 1.497 4.527 4.527 0 0 1 1.013 3.912.47.47 0 0 1-.92-.2 3.573 3.573 0 0 0-.8-3.09 3.574 3.574 0 0 0-2.963-1.181Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1ZM2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8Z" })));
});
